module.exports = __webpack_public_path__ + "img/16_54.f1dc41cd.png";